
import { PencilIcon, XMarkIcon as XIcon } from '@heroicons/vue/20/solid'

export default {
  name: 'DeliveryAddressRow',
  components: {
    PencilIcon,
    XIcon
  },
  props: {
    deliveryAddress: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    topAddressLine() {
      const a = this.deliveryAddress.attributes
      return [a.address1, a.address2].filter(Boolean).join(', ')
    },
    bottomAddressLine() {
      const a = this.deliveryAddress.attributes
      return [a.city, a.state, a.postal_code].filter(Boolean).join(', ')
    },
    notes() {
      return this.deliveryAddress.attributes.notes
    },
    isDefault() {
      return !!this.deliveryAddress.attributes.is_default
    }
  },
  methods: {
    editAddress() {
      this.$emit('edit-address', this.deliveryAddress)
    },
    removeAddress() {
      this.$emit('remove-address', this.deliveryAddress)
    }
  }
}
